import { render, staticRenderFns } from "./OrganisationSettings.vue?vue&type=template&id=ae9ed784&scoped=true"
import script from "./OrganisationSettings.vue?vue&type=script&lang=js"
export * from "./OrganisationSettings.vue?vue&type=script&lang=js"
import style0 from "./OrganisationSettings.vue?vue&type=style&index=0&id=ae9ed784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9ed784",
  null
  
)

export default component.exports